import { render, staticRenderFns } from "./cm_industry.vue?vue&type=template&id=645a5eae&scoped=true"
import script from "./cm_industry.vue?vue&type=script&lang=js"
export * from "./cm_industry.vue?vue&type=script&lang=js"
import style0 from "./cm_industry.vue?vue&type=style&index=0&id=645a5eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a5eae",
  null
  
)

export default component.exports